// extracted by mini-css-extract-plugin
export default {"content":"ModalCrearFormacion_content__PFv7z","intro":"ModalCrearFormacion_intro__OYCoj","input":"ModalCrearFormacion_input__Rnpwo"};